<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  isVoiceType: {
    type: Boolean,
    default: false,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  isSelectable: {
    type: Boolean,
    default: false,
  },
  selectedIds: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  'edit',
  'rename',
  'select',
  'delete',
  'stop',
  'viewSends',
  'open',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleRename = campaign => emit('rename', campaign);
const handleSelect = campaign => emit('select', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleStop = campaign => emit('stop', campaign);
const handleViewSends = campaign => emit('viewSends', campaign);
const handleOpen = campaign => emit('open', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :total-recipients-count="campaign.total_recipients_count"
      :processed-recipients-count="campaign.processed_recipients_count"
      :campaign-sends-summary="campaign.campaign_sends_summary"
      :engagement="campaign.engagement"
      :is-live-chat-type="isLiveChatType"
      :is-voice-type="isVoiceType"
      :read-only="readOnly"
      :phone-number="campaign.voice_phone_number"
      :dialer-config="campaign.dialer_config"
      :is-selectable="isSelectable"
      :is-selected="selectedIds.includes(campaign.id)"
      @edit="handleEdit(campaign)"
      @rename="handleRename(campaign)"
      @select="handleSelect(campaign)"
      @delete="handleDelete(campaign)"
      @stop="handleStop(campaign)"
      @view-sends="handleViewSends(campaign)"
      @open="handleOpen(campaign)"
    />
  </div>
</template>
